<template>
  <div>
    <div class="d-flex mt-8 mx-9" v-if="step === 2">
      <div>
        <h2 style="color: #0D0D0E">Rodada de compras</h2>
        <p class="mt-2">Crie uma ou mais rodadas de compra. Cada rodada define qual período de referência você quer
          usar na análise
          e em qual período você comprará com base nessa análise.</p>
      </div>
    </div>

    <div class="mx-9 px-6 py-5 mt-4 border-gray-400 bra-6" v-if="step === 2">
      <v-form v-model="form_valido" ref="form_ref">
        <div class="d-flex">
          <div class="w-80-porcento">
            <v-text-field
              class="mr-4 mb-7 input-clean"
              v-model="form.nome"
              :rules="rules.required"
              hide-details="auto"
              label="Nome*"
              maxlength="100"
              outlined
              dense
              single-line
            />

            <div class="d-flex">
              <div class="w-50-porcento">
                <SysTooltip2
                  text="Período de vendas histórico que você quer cobrir com a compra. O sistema usa as vendas desse período (no passado) como base de volume."
                  top
                >
                  <template #activator>
                    <h4 class="mb-2" style="color: #0D0D0E">
                      Período de Referência (Histórico de Vendas)<span style="color: #F20325"> *</span></h4>
                  </template>
                </SysTooltip2>

                <div class="d-flex">
                  <div class="w-50-porcento mr-3">
                    <span class="label-input-date">Inicio</span>
                    <SysDatePicker
                      v-model="form.data_inicio_referencia"
                      titulo_label=""
                      placeholder="DD/MM/AAAA"
                      append_icon="$CalendarBlank"
                      outlined
                      :rules="rules.requiredDate"
                      :data_maxima="DATA_ATUAL"
                    />
                  </div>

                  <div class="w-50-porcento mr-15">
                    <span class="label-input-date">Fim</span>
                    <SysDatePicker
                      v-model="form.data_fim_referencia"
                      titulo_label=""
                      placeholder="DD/MM/AAAA"
                      append_icon="$CalendarBlank"
                      outlined
                      :rules="rules.referenciaFimMaiorQueInicio"
                      :data_minima="DATA_MINIMA_INICIO"
                    />
                  </div>
                </div>
              </div>

              <div class="w-50-porcento">
                <SysTooltip2
                  text="Período em que você fará a compra. As sugestões de compra desse período serão influenciadas por esta rodada."
                  top
                >
                  <template #activator>
                    <h4 class="mb-2" style="color: #0D0D0E">
                      Período de Aplicação (quando vou comprar, com base no Histórico de Vendas)
                      <span style="color: #F20325"> *</span></h4>
                  </template>
                </SysTooltip2>

                <div class="d-flex">
                  <div class="w-50-porcento mr-5">
                    <span class="label-input-date">Inicio</span>
                    <SysDatePicker
                      v-model="form.data_inicio_aplicacao"
                      titulo_label=""
                      placeholder="DD/MM/AAAA"
                      append_icon="$CalendarBlank"
                      outlined
                      :rules="rules.requiredDate"
                      :data_minima="DATA_ATUAL"
                    />
                  </div>

                  <div class="w-50-porcento mr-4">
                    <span class="label-input-date">Fim</span>
                    <SysDatePicker
                      v-model="form.data_fim_aplicacao"
                      titulo_label=""
                      placeholder="DD/MM/AAAA"
                      append_icon="$CalendarBlank"
                      outlined
                      :rules="rules.aplicacaoFimMaiorQueInicio"
                      :data_minima="DATA_ATUAL"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="d-flex align-center font-14 pa-3 bra-7 w-50-porcento"
              v-if="!DISABLED_SALVAR_RODADA && !mensagem_erro"
              style="background-color: #F2F6FC; color: #19191C;"
            >
              <v-icon color="#0CB935" size="20" class="mr-2">$CheckCircle</v-icon>
              <span>Você vai comprar em <strong>{{ formatarDataMesAno(form.data_inicio_aplicacao) }}</strong> para cobrir vendas de <strong>{{
                  formatarDataMesAno(form.data_inicio_referencia)
                }}</strong> á <strong>{{ formatarDataMesAno(form.data_fim_referencia) }}</strong>.</span>
            </div>

            <div
              class="d-flex align-center font-14 pa-3 bra-7 w-50-porcento"
              style="background-color: #F2F6FC; color: #19191C;"
              v-if="mensagem_erro"
            >
              <v-icon color="#F2A202" size="20" class="mr-2">$Warning</v-icon>
              <span>{{ mensagem_erro }}</span>
            </div>
          </div>

          <div class="d-flex justify-center align-center flex-column w-20-porcento">
            <v-btn
              class="vbtn-class bra-8 pr-6 text-transform-none"
              color="#4075FF"
              height="50"
              :disabled="DISABLED_SALVAR_RODADA"
              @click="salvarRodadaCompras()"
            >
              <SysTooltip2
                text="Uma rodada define qual período de vendas você quer cobrir e quando você vai comprar para cobrir."
                top
              >
                <template #activator>
                  <span style="color: #FFFFFF;">
                    <v-icon color="#FFFFFF" class="mr-2 ml-1">$FloppyDisk</v-icon>
                    {{ editando_rodada ? "Salvar rodada" : "Adicionar rodada" }}
                  </span>
                </template>
              </SysTooltip2>
            </v-btn>

            <v-btn
              v-if="editando_rodada"
              class="mt-2 text-transform-none"
              color="#4075FF"
              icon
              @click="cancelarEdicaoRodadaCompra"
            >
              <span>Cancelar</span>
            </v-btn>
          </div>
        </div>
      </v-form>
    </div>

    <div class="mx-9 py-1 mt-6 bra-6" v-if="step === 2">
      <div v-if="rodadas_compra && rodadas_compra.length">
        <v-row dense>
          <v-col
            v-for="(rodada, index) in rodadas_compra"
            :key="rodada.id || index"
            cols="12"
          >
            <v-card class="pa-4" outlined>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <h2 class="font-weight-medium" style="color: #0D0D0E">#{{ rodada.id }} - {{ rodada.nome }}</h2>
                  <div class="mt-2 text-body-2" style="color:#19191C">
                    Comprar em <b>{{ formatarDataMesAno(rodada.data_inicio_aplicacao) }}</b> -
                    <b>{{ formatarDataMesAno(rodada.data_fim_aplicacao) }}</b>
                    com base nas vendas de <b>{{ formatarDataMesAno(rodada.data_inicio_referencia) }}</b> -
                    <b>{{ formatarDataMesAno(rodada.data_fim_referencia) }}</b>
                  </div>
                </div>

                <div class="d-flex">
                  <v-btn
                    class="mr-10"
                    alt="trash.btn"
                    icon
                    @click="excluirRodadaCompra(rodada.id)"
                  >
                    <v-icon color="#4075FF">$Trash</v-icon>
                  </v-btn>

                  <v-btn
                    class="mr-10"
                    alt="pencil-simple.btn"
                    icon
                    @click="editarRodadaCompra(rodada)"
                  >
                    <v-icon color="#4075FF">$PencilSimple</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div
        class="d-flex justify-center align-center flex-column pl-2"
        v-else
      >
        <v-icon size="80" color="#CFD1D7">$Basket</v-icon>

        <h3 class="my-1 font-weight-medium" style="color: #19191C">
          Nenhuma rodada criada
        </h3>
        <p style="color: #73787F">
          Adicione ao menos uma rodada para continuar
        </p>
      </div>
    </div>

    <DialogExcluirRodadaCompra
      v-model="dialog_excluir_rodada"
      :id_rodada="id_rodada_acao"
      @confirmar="() => rodadas_compra.pop()"
      @fechar="dialog_excluir_rodada = false;"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from "vue";

import SysTooltip2 from "@/components/utils/ui_v4/tooltips/SysTooltip2.vue";
import { toast2 } from "@/components/utils/ui_v4/alerts/toast/toast2";
import SysDatePicker from "@/components/utils/SysDatePicker.vue";
import moment from "moment";
import api from "@/api/api";

import DialogExcluirRodadaCompra
  from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/AplicacaoTipoProjecao/CompraSazonal/components/dialog/DialogExcluirRodadaCompra.vue";

const emit = defineEmits(['atualizar:rodada-compra']);

watch(
  () => props.step,
  (newStep) => {
    if (newStep === 2 && !rodadas_compra_buscada.value) {
      buscarRodadasCompras();
      rodadas_compra_buscada.value = true;
    }
  }
);

const form_ref = ref(null);
const form_valido = ref(false);

const editando_rodada = ref(false);

const dialog_excluir_rodada = ref(false);
const id_rodada_acao = ref(0);

const mensagem_erro = ref('');
const rodadas_compra = ref([]);
const rodadas_compra_buscada = ref(false);

const DATA_ATUAL = computed(() => moment().format('YYYY-MM-DD'));
const DATA_MINIMA_INICIO = computed(() => {
  if (!form.data_inicio_referencia) return '';

  return moment(form.data_inicio_referencia)
  .add(1, 'month')
  .format('YYYY-MM-DD');
});

const DISABLED_SALVAR_RODADA = computed(() => {
  const preenchido =
    form.nome.trim().length > 0 &&
    !!form.data_inicio_referencia &&
    !!form.data_fim_referencia &&
    !!form.data_inicio_aplicacao &&
    !!form.data_fim_aplicacao;

  return !preenchido || !form_valido.value;
});

const props = defineProps({
  step: { type: Number, required: true },
  edicao_rodada_compra_existente: { type: Boolean, default: false, required: false },
  rodada_compra: { type: Object, default: {}, required: false },
  produtos_selecionados: { type: Array, required: true },
});

const formInicial = () => ({
  nome: '',
  data_inicio_referencia: '',
  data_fim_referencia: '',
  data_inicio_aplicacao: '',
  data_fim_aplicacao: '',
});

const form = reactive(formInicial());

function formatarDataMesAno(data) {
  if (!data || typeof data !== "string") return "";

  const meses = [
    "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
    "Jul", "Ago", "Set", "Out", "Nov", "Dez"
  ];

  let yyyy, mm;
  let m = data.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (m) {
    yyyy = m[1];
    mm = m[2];
  } else {
    m = data.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!m) return "";
    yyyy = m[3];
    mm = m[2];
  }

  const mesNum = Number(mm);
  if (!Number.isInteger(mesNum) || mesNum < 1 || mesNum > 12) return "";

  return `${meses[mesNum - 1]}/${yyyy}`;
}

function buscarRodadasCompras() {
  mensagem_erro.value = null;

  const params = {
    id_rodada_compra: props.rodada_compra ? props.rodada_compra.id : null
  }

  if (!params.id_rodada_compra) {
    return;
  }

  api.get('eventos-sazonais/compra-sazonal/buscar-rodadas-compras', { params })
  .then((response) => {
    if (response.data.length > 0) {
      rodadas_compra.value = response.data;
      emit('atualizar:rodada-compra', rodadas_compra.value);
    }
  })
  .catch();
}

function salvarRodadaCompras() {
  const body = {
    nome: form.nome,
    data_inicio_referencia: form.data_inicio_referencia,
    data_fim_referencia: form.data_fim_referencia,
    data_inicio_aplicacao: form.data_inicio_aplicacao,
    data_fim_aplicacao: form.data_fim_aplicacao,
    produtos: props.produtos_selecionados
  }

  if (editando_rodada.value) {
    api.put(`eventos-sazonais/compra-sazonal/atualizar-rodada-compra/${id_rodada_acao.value}`, body)
    .then((response) => {
      const rodada_atualizada = response.data.data;

      rodadas_compra.value = rodadas_compra.value.map((r) =>
        r.id === rodada_atualizada.id ? rodada_atualizada : r
      );

      emit('atualizar:rodada-compra', rodadas_compra.value);

      toast2.success('Rodada de compra salva com sucesso!');

      Object.assign(form, formInicial());
      form_ref.value.resetValidation();

      mensagem_erro.value = null;
      editando_rodada.value = false;
    })
    .catch((err) => {
      mensagem_erro.value = err.response.data.message;
      toast2.error('Falha ao salvar a rodada de compra.')
    });

    return;
  }

  api.post('eventos-sazonais/compra-sazonal/salvar-rodada-compra', body)
  .then((response) => {
    rodadas_compra.value.push(response.data.data);
    toast2.success('Rodada de compra salva com sucesso!');

    emit('atualizar:rodada-compra', rodadas_compra.value);

    Object.assign(form, formInicial());
    form_ref.value.resetValidation();

    mensagem_erro.value = null;
  })
  .catch((err) => {
    mensagem_erro.value = err.response.data.message;
    toast2.error('Falha ao salvar a rodada de compra.')
  });
}

const isRequired = (msg = "Defina um nome para essa rodada de compras.") => (v) =>
  !!(typeof v === "string" ? v.trim() : v) || msg;

const isRequiredDate = (msg = "Defina uma data para o período.") => (v) => {
  if (!v) return msg;
  if (v instanceof Date) return !isNaN(v.getTime()) || msg;
  if (typeof v === "string") return v.trim().length > 0 || msg;

  return true;
};

const fimMaiorQueInicio = (getInicio, msg) => (fim) => {
  const inicio = getInicio();

  if (!fim) return true;
  if (!inicio) return true;

  const I = moment(inicio, "YYYY-MM-DD", true).format("YYYYMMDD");
  const F = moment(fim, "DD/MM/YYYY", true).format("YYYYMMDD");

  if (F < I) return msg;

  return true;
};

const editarRodadaCompra = (rodada) => {
  editando_rodada.value = true;
  id_rodada_acao.value = rodada.id;

  Object.assign(form, {
    nome: rodada.nome ? rodada.nome : '',
    data_inicio_referencia: rodada.data_inicio_referencia ? rodada.data_inicio_referencia : '',
    data_fim_referencia: rodada.data_fim_referencia ? rodada.data_fim_referencia : '',
    data_inicio_aplicacao: rodada.data_inicio_aplicacao ? rodada.data_inicio_aplicacao : '',
    data_fim_aplicacao: rodada.data_fim_aplicacao ? rodada.data_fim_aplicacao : '',
  });
};

const excluirRodadaCompra = (id) => {
  dialog_excluir_rodada.value = true;
  id_rodada_acao.value = id;
};

const cancelarEdicaoRodadaCompra = () => {
  editando_rodada.value = false;
  Object.assign(form, formInicial());

  form_ref.value.resetValidation();
};

const rules = {
  required: [isRequired()],
  requiredDate: [isRequiredDate()],
  referenciaFimMaiorQueInicio: [
    isRequiredDate(),
    fimMaiorQueInicio(() => form.data_inicio_referencia, "Data fim anterior a data de início."),
  ],
  aplicacaoFimMaiorQueInicio: [
    isRequiredDate(),
    fimMaiorQueInicio(() => form.data_inicio_aplicacao, "Data fim anterior a data de início."),
  ],
};
</script>

<style scoped>
.label-input-date {
  color: #0D0D0E;
  font-weight: 500;
}

::v-deep(.input-clean.v-text-field--outlined .v-input__control > .v-input__slot) {
  background: #fff;
  border-radius: 4px;
  min-height: 50px;
}

::v-deep(.input-clean.v-text-field--outlined fieldset) {
  border-width: 1px;
}

::v-deep(.input-clean.v-text-field--outlined .v-label) {
  color: #73787F;
  text-align: center;
  margin-top: 5px;
  font-size: 14px;
}

</style>
